// Uniform grid in normalised [-1, 1] space. Chapter 01 samples 32x32;
// chapter 42 samples 90x90 character cells. Same topology, different density.
//
// Points are stride 3. A grid is a planar topology, so its own z is 0 — the
// height comes from the motion stage displacing by the field value. Carrying
// the column anyway keeps every substrate one shape, so a volumetric topology
// can be added later without touching the motion stage.
import { mulberry32 } from '../rng.js'

export default {
  id: 'grid',
  label: 'Grid',
  motion: 'resample',
  params: [
    { key: 'density', label: 'density', tier: 'structural', min: 6, max: 90, step: 1, default: 38 },
    { key: 'jitter', label: 'jitter', tier: 'structural', min: 0, max: 1, step: 0.02, default: 0 },
    // Which way a path mark walks this lattice. It changes the emission order,
    // so it also changes which jitter goes to which point — 'columns' is the
    // order the grid has always emitted in, and stays the default.
    { key: 'chain', label: 'chain', tier: 'structural', type: 'enum', default: 'columns',
      options: [
        { value: 'columns', label: 'columns' },
        { value: 'rows', label: 'rows' },
      ] },
  ],

  build(cfg, seed) {
    const rnd = mulberry32(seed)
    const n = cfg.density
    const pts = new Float32Array(n * n * 3)
    const cell = 2 / (n - 1 || 1)
    const rows = cfg.chain === 'rows'
    let i = 0
    for (let a = 0; a < n; a++) {
      for (let b = 0; b < n; b++) {
        const u = (a / (n - 1 || 1)) * 2 - 1 + (rnd() - 0.5) * cell * cfg.jitter
        const v = (b / (n - 1 || 1)) * 2 - 1 + (rnd() - 0.5) * cell * cfg.jitter
        // Consecutive points share a line, so a path mark strokes it: with
        // 'columns' the inner loop varies y, with 'rows' it varies x.
        pts[i++] = rows ? v : u
        pts[i++] = rows ? u : v
        pts[i++] = 0
      }
    }
    // n runs of n, open at both ends.
    const runs = new Int32Array(n)
    runs.fill(n)
    return { points: pts, count: n * n, runs, closed: false }
  },
}
